import * as React from 'react';

import { Button, Dialog, Image, Notification } from 'components';

import { TEXT } from 'texts';
import { observer } from 'mobx-react-lite';
import { octopusImage } from 'images';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';

type ErrorProviderProps = {};

export const ErrorProvider: React.FC<React.PropsWithChildren<ErrorProviderProps>> = observer(({ children }) => {
  const { t } = useTranslation();
  const { errorStore } = useStores();
  return (
    <>
      <Dialog open={errorStore.hasError} fullScreen hideBackdrop>
        <Notification
          image={<Image {...octopusImage} />}
          title={errorStore.error.title}
          description={errorStore.error.description}
          button={
            errorStore.error.callback && (
              <Button
                fullWidth
                onClick={() => {
                  errorStore.error.callback && errorStore.error.callback();
                  errorStore.setError({});
                }}
              >
                {t(TEXT.tryAgain)}
              </Button>
            )
          }
        />
      </Dialog>
      {children}
    </>
  );
});
